import { render } from "./TableLoader.vue?vue&type=template&id=2519f001"
import script from "./TableLoader.vue?vue&type=script&lang=js"
export * from "./TableLoader.vue?vue&type=script&lang=js"
script.render = render

export default script